import { mn } from "../../../../date-fns/locale/mn.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    mn
  }
};